/** Shared tournament stage labels used across organizer + public views. */

export const GROUP_STAGE_NAME = 'Group Stage';

export const KNOCKOUT_STAGE_OPTIONS = [
  { value: 'Round of 16', label: 'Round of 16' },
  { value: 'Quarter Finals', label: 'Quarter Finals' },
  { value: 'Semi Finals', label: 'Semi Finals' },
  { value: 'Third Place', label: 'Third Place' },
  { value: 'Finals', label: 'Finals' },
];

export const FIXTURE_SCOPE_OPTIONS = [
  { value: 'group', label: 'Group Stage' },
  { value: 'knockout', label: 'Knockout Stage' },
];
